import React, { ReactElement } from 'react'

/**
 * Context menu option object type.
 */
export type ContextMenuOption = {
    itemName?: string
    URL?: string
    target?: string
    isEnabled: boolean
    isHidden?: boolean
    icon?: ReactElement
    onClick?: (event: React.MouseEvent) => void
    onMouseOver?: (event?: React.MouseEvent) => void
    onMouseOut?: (event?: React.MouseEvent) => void
}
